import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

function AuthGuard({ children }) {
  const account = useSelector(state => state.account);

  if (!account.user) {
    return <Redirect to="/login" />;
  }

  if (account.user.roles) {
    if (
      account.user.roles.length > 0 &&
      account.user.roles[0].name === 'admin'
    ) {
      return <Redirect to="/alagang-abc/dashboard" />;
    }
  }
  if (account.user.roles) {
    if (
      account.user.roles.length > 0 &&
      account.user.roles[0].name === 'front desk'
    ) {
      return <Redirect to="/alagang-abc/front-desk/voters" />;
    }
  }
  if (account.user.roles) {
    if (
      account.user.roles.length > 0 &&
      account.user.roles[0].name === 'poll watcher'
    ) {
      return <Redirect to="/alagang-abc/poll-watcher/report" />;
    }
  }
  if (account.user.roles) {
    if (
      account.user.roles.length > 0 &&
      account.user.roles[0].name === 'doc track'
    ) {
      return <Redirect to="/alagang-abc/receiver/documents" />;
    }
  }
  if (account.user.roles) {
    if (
      account.user.roles.length > 0 &&
      account.user.roles[0].name === 'doc track admin'
    ) {
      return <Redirect to="/alagang-abc/doc-track-admin/documents" />;
    }
  }

  return children;
}

AuthGuard.propTypes = {
  children: PropTypes.any
};

export default AuthGuard;
